import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from "react";
/* 

  const {toggleDialog, comp} = useDialog({
    ModalComponent: SimpleInsertData,
    validateAgainstSchema,
  });

  return <div>
    {comp} //stick the returned dialog comp somewhere in the dom! (it should not effect layout)
    {...your code here}
  </div>

*/

export var useDialog = function useDialog(_ref) {
  var ModalComponent = _ref.ModalComponent,
      rest = _objectWithoutPropertiesLoose(_ref, ["ModalComponent"]);

  var _useState = useState(false),
      isOpen = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState(false),
      additionalProps = _useState2[0],
      setAdditionalProps = _useState2[1];

  var comp = /*#__PURE__*/React.createElement(ModalComponent, _extends({
    hideModal: function hideModal() {
      setOpen(false);
    }
  }, rest, additionalProps, {
    dialogProps: _extends({
      isOpen: isOpen
    }, rest == null ? void 0 : rest.dialogProps, additionalProps == null ? void 0 : additionalProps.dialogProps)
  }));

  var toggleDialog = function toggleDialog() {
    setOpen(!isOpen);
  };

  function showDialogPromise(_x, _x2) {
    return _showDialogPromise.apply(this, arguments);
  }

  function _showDialogPromise() {
    _showDialogPromise = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(handlerName, moreProps) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (moreProps === void 0) {
                moreProps = {};
              }

              return _context.abrupt("return", new Promise(function (resolve) {
                var _extends2;

                //return a promise that can be awaited
                setAdditionalProps(_extends((_extends2 = {
                  hideModal: function hideModal() {
                    //override hideModal to resolve also
                    setOpen(false);
                    resolve({});
                  }
                }, _extends2[handlerName] = function (r) {
                  setOpen(false);
                  resolve(r || {});
                }, _extends2), moreProps));
                setOpen(true); //open the dialog
              }));

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _showDialogPromise.apply(this, arguments);
  }

  return {
    comp: comp,
    showDialogPromise: showDialogPromise,
    toggleDialog: toggleDialog,
    setAdditionalProps: setAdditionalProps
  };
};